import React, { useContext, useCallback } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { id } from '../../../../filters/options/return-received';
import DateRangePicker from '../../../components/date-range-picker';

import { AdvancedSearchShipmentContext } from '../../context';
import messages from '../messages';

import baseStyle from '../../../style.module.less';

const ReturnReceived = ({ dateFormat }) => {
  const { filters, updateFilter } = useContext(AdvancedSearchShipmentContext);
  const { value: shipDates = {} } = filters.find((filter) => filter.id === id) || {};

  const updateDateFilter = useCallback(
    (dates) => {
      updateFilter(id, dates);
    },
    [updateFilter],
  );

  const { from = null, to = null } = shipDates;

  return (
    <span className={baseStyle.filterInput}>
      <label className={baseStyle.filterLabel}>
        <FormattedMessage {...messages.returnReceived} />
      </label>
      <DateRangePicker dateFormat={dateFormat} from={from} setDates={updateDateFilter} to={to} />
    </span>
  );
};

ReturnReceived.propTypes = {
  dateFormat: PropTypes.string.isRequired,
};

export default ReturnReceived;
